module.exports = __webpack_public_path__ + "static/media/fig_12a.613e9782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_12a.jpg
// module id = 631
// module chunks = 0